// src/pages/copilot/components/SessionSidebar.jsx
import { Plus, X } from 'lucide-react';

const STATE_LABEL = {
  idle: 'idle',
  thinking: 'thinking…',
};

export default function SessionSidebar({ sessions, activeId, onNew, onSelect, onDelete }) {
  return (
    <div className="quick-actions-panel">
      <button className="primary-btn" onClick={onNew}>
        <Plus size={16} /> New session
      </button>
      {sessions.length > 0 && <h4>Sessions</h4>}
      <div className="sessions-list">
        {sessions.length === 0 && (
          <p className="muted" style={{ fontSize: 12, marginTop: 4 }}>
            No sessions yet. Click "New session" to start.
          </p>
        )}
        {sessions.map((s) => (
          <div
            key={s.id}
            className={`session-row ${s.id === activeId ? 'active' : ''}`}
            onClick={() => onSelect(s.id)}
          >
            <div className="session-title">
              {s.updated_at ? new Date(s.updated_at).toLocaleString() : `Session #${s.id}`}
            </div>
            <div className="session-state">{STATE_LABEL[s.state] || s.state}</div>
            <button
              className="icon-btn"
              onClick={(e) => { e.stopPropagation(); onDelete(s.id); }}
              aria-label="Delete"
            >
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
